import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyBsgUAuWiUvdXcs7d58JUWju119pcR3NRM",
    authDomain: "linkedin-clone-f38dc.firebaseapp.com",
    projectId: "linkedin-clone-f38dc",
    storageBucket: "linkedin-clone-f38dc.appspot.com",
    messagingSenderId: "767509922322",
    appId: "1:767509922322:web:eeef8521f1bd91edad4ecb"
  };

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const auth= firebase.auth();

export {db,auth};